export default __webpack_public_path__ + "static/bucket-6ee1e4a56c83bbdc2bbdc4f8a757f890.gif";